<ng-container *ngIf="selectedSchool">
  <span *ngIf="includeDash"> - </span> {{ selectedSchool.title }}
</ng-container>
